var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowCipa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 160,
    viewBox: "0 0 125 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6685 33.1212L0.599941 40.1169L13.8452 27.3457H37.6685V33.1212Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7735 90.1836C65.0892 109.18 64.4049 128.18 63.7247 147.176C64.6481 147.79 66.0992 148.932 67.2452 150.816C69.2239 154.072 68.9601 157.346 68.8241 158.459H30.3581C29.6944 156.966 27.3899 151.319 29.8716 146.689C33.1077 140.654 43.6528 137.867 54.1772 143.202C55.0017 125.529 55.8303 107.856 56.6548 90.1836H65.7776H65.7735Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0674 90.1828C74.3299 109.179 78.5925 128.179 82.855 147.175C81.9316 147.789 80.4805 148.931 79.3345 150.815C77.3558 154.072 77.6196 157.345 77.7556 158.458H116.226C116.782 157.238 119.243 151.524 116.712 146.688C113.575 140.699 103.69 137.801 93.9525 142.475C88.8284 125.042 83.7084 107.612 78.5842 90.1787H70.0674V90.1828Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3421 95.6022L72.8733 102.464L82.3921 103.639L79.4506 94.4541L71.3421 95.6022Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2696 101.907L65.01 105.217L65.3167 96.5931L56.8616 95.4141L56.2696 101.907Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5959 74.3449C94.7842 77.7789 101.821 82.2682 110.87 82.5444C111.731 82.5691 122.347 82.7876 123.608 78.7765C124.437 76.1505 120.669 73.5576 115.149 66.8463C110.82 61.5861 107.856 56.7671 105.977 53.3867",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5959 74.3449C94.7842 77.7789 101.821 82.2682 110.87 82.5444C111.731 82.5691 122.347 82.7876 123.608 78.7765C124.437 76.1505 120.669 73.5576 115.149 66.8463C110.82 61.5861 107.856 56.7671 105.977 53.3867",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3305 10.2172C94.4719 14.3643 117.677 54.4092 102.057 80.5451C88.5933 103.074 53.9694 102.398 34.0294 93.7491C16.7855 86.267 1.95312 69.1096 5.23866 62.9549C7.55132 58.6305 18.6694 60.0239 27.6768 61.8748C27.5325 57.6906 27.6521 52.8056 28.3199 47.4011C29.1032 41.0568 30.4512 35.5575 31.8652 31.06C33.8439 27.6714 40.3861 17.4685 53.4747 12.5464C55.1154 11.928 64.094 8.67544 72.3264 10.2172H72.3305Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2238 56.7871H92.2196C87.4681 56.7871 83.6162 52.9352 83.6162 48.1837V46.6254C83.6162 41.8739 87.4681 38.022 92.2196 38.022H92.2238C96.9753 38.022 100.827 41.8739 100.827 46.6254V48.1837C100.827 52.9352 96.9753 56.7871 92.2238 56.7871Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.049 52.4301C90.9089 52.4301 89.174 49.9643 89.174 46.9225C89.174 43.8808 90.9089 41.415 93.049 41.415C95.1892 41.415 96.9241 43.8808 96.9241 46.9225C96.9241 49.9643 95.1892 52.4301 93.049 52.4301Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7415 39.7588L93.2173 44.112L88.1632 43.2834L91.7415 39.7588Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5148 57.2617H76.5106C71.7591 57.2617 67.9072 53.4098 67.9072 48.6583V47.1C67.9072 42.3485 71.7591 38.4966 76.5106 38.4966H76.5148C81.2663 38.4966 85.1182 42.3485 85.1182 47.1V48.6583C85.1182 53.4098 81.2663 57.2617 76.5148 57.2617Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3383 52.9086C75.1982 52.9086 73.4633 50.4428 73.4633 47.4011C73.4633 44.3594 75.1982 41.8936 77.3383 41.8936C79.4785 41.8936 81.2134 44.3594 81.2134 47.4011C81.2134 50.4428 79.4785 52.9086 77.3383 52.9086Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.032 40.2363L77.5078 44.5896L72.4538 43.761L76.032 40.2363Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1063 31.7644L75.859 30.5348C77.1671 30.2966 78.4206 31.1639 78.6588 32.472L78.7615 33.0358C78.9997 34.3439 78.1323 35.5974 76.8242 35.8356L70.0715 37.0652C68.7634 37.3034 67.5099 36.4361 67.2717 35.128L67.169 34.5642C66.9308 33.2561 67.7982 32.0026 69.1063 31.7644Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1285 35.1856L89.3515 33.9515C88.0501 33.7146 87.1872 32.4675 87.4242 31.1661L87.5313 30.578C87.7682 29.2766 89.0153 28.4138 90.3167 28.6507L97.0938 29.8848C98.3952 30.1218 99.258 31.3688 99.0211 32.6702L98.914 33.2583C98.677 34.5597 97.4299 35.4226 96.1285 35.1856Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0718 29.5095C30.8394 30.1155 20.7478 31.8222 9.88939 35.994C6.54201 37.2802 3.4461 38.6777 0.605778 40.1123C0.667614 37.4781 1.27772 35.4087 2.05685 33.7886C6.5214 24.4967 21.2012 20.3125 38.7131 22.6169C38.8327 24.9131 38.9522 27.2092 39.0718 29.5054V29.5095Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7744 22.2746C85.2981 5.45111 67.2916 -2.95856 52.2819 2.0254C40.0426 6.09008 31.3691 18.5438 31.3897 32.7825C40.7393 29.5135 52.1748 26.3434 65.3994 24.3523C75.0829 22.897 83.9625 22.3364 91.7744 22.2746Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1804 17.9745C80.8159 12.0135 75.094 9.23912 71.3715 10.7314C68.6425 11.828 66.7668 15.3114 67.043 19.2112C72.0888 18.7989 77.1346 18.3867 82.1804 17.9745Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5034 17.4922C82.0172 18.0652 74.5309 18.6382 67.0405 19.2112C63.9199 18.9309 61.7062 20.584 61.5825 22.1711C61.4835 23.4243 62.6997 24.4755 63.013 24.727",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4598 57.4787L73.9448 79.4355L69.5443 90.5556L14.0593 68.5987L18.4598 57.4787Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6235 59.7188L21.7726 64.3977",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1001 61.5693L26.2491 66.2441",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6301 63.2754L30.7792 67.9543",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1462 65.0283L35.2953 69.7072",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6711 66.7559L39.8202 71.4348",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1802 68.5195L44.3292 73.1943",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6345 70.4248L48.7836 75.1037",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1453 72.1719L53.2943 76.8508",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5586 74.1885L57.7076 78.8674",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9714 76.2002L62.1205 80.875",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4963 77.9268L66.6454 82.6015",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2126 61.2972C60.2339 71.8999 53.7741 79.8685 45.4922 81.872C40.8463 82.9974 34.0073 82.7459 32.416 79.514C31.3937 77.4404 32.9973 75.103 36.8641 67.9548C39.8858 62.3648 42.2149 57.6777 43.7773 54.4375",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2126 61.2972C60.2339 71.8999 53.7741 79.8685 45.4922 81.872C40.8463 82.9974 34.0073 82.7459 32.416 79.514C31.3937 77.4404 32.9973 75.103 36.8641 67.9548C39.8858 62.3648 42.2149 57.6777 43.7773 54.4375",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0119 53.1514C92.1354 53.5801 100.075 54.656 100.483 57.6613C100.652 58.9186 99.4526 60.0976 98.5251 61.0045C93.3968 66.0297 85.7786 64.121 84.0431 63.6387",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0119 53.1514C92.1354 53.5801 100.075 54.656 100.483 57.6613C100.652 58.9186 99.4526 60.0976 98.5251 61.0045C93.3968 66.0297 85.7786 64.121 84.0431 63.6387",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2107 59.4347C86.4804 59.715 87.8861 59.9335 89.4155 60.0242C93.9172 60.288 97.7139 59.344 100.451 58.334",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCipa);
export default __webpack_public_path__ + "static/media/yellow-cipa.fccf353270d22b401fe9ea910f24d877.svg";
export { ForwardRef as ReactComponent };